import Avisos from '@/repositories/Avisos';

// state
const state = () => ({
  existeComplemento: false
});

// getters
const getters = {
  getExisteComplemento: (state) => {
    return state.existeComplemento
  },
};

// mutations
const mutations = {
  SET_EXISTE_COMPLEMENTO (state, existeComplemento) {
    state.existeComplemento = existeComplemento
  },
}

// actions
const actions = {
  setExisteComplemento ({ commit }, existeComplemento) {
    commit('SET_EXISTE_COMPLEMENTO', existeComplemento)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
